"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUTMValues = void 0;
const react_1 = require("react");
const DEFAULT_UTM_MEDIUM_OLD_DEEP_LINK = "NA";
const DEFAULT_UTM_CAMPAIGN_OLD_DEEP_LINK = "NA";
const DEFAULT_UTM_SOURCE_OLD_DEEP_LINK = "NA";
const DEFAULT_UTM_MEDIUM_WITHOUT_DEEP_LINK = "web_open";
const DEFAULT_UTM_CAMPAIGN_WITHOUT_DEEP_LINK = "direct_web_open";
const DEFAULT_UTM_SOURCE_WITHOUT_DEEP_LINK = "opensooq";
const getCampaignUTMs = () => {
    const query = new URLSearchParams(window.location.search);
    const requestUri = window.location.href;
    const terms = ["countryCode", "DeeplinkRoot", "DeeplinkParams"];
    const hasUTMInURL = terms.some(term => requestUri.includes(term));
    const defaultMedium = hasUTMInURL ? DEFAULT_UTM_MEDIUM_OLD_DEEP_LINK : DEFAULT_UTM_MEDIUM_WITHOUT_DEEP_LINK;
    const defaultCampaign = hasUTMInURL ? DEFAULT_UTM_CAMPAIGN_OLD_DEEP_LINK : DEFAULT_UTM_CAMPAIGN_WITHOUT_DEEP_LINK;
    const defaultSource = hasUTMInURL ? DEFAULT_UTM_SOURCE_OLD_DEEP_LINK : DEFAULT_UTM_SOURCE_WITHOUT_DEEP_LINK;
    return {
        campaignMedium: query.get("utm_medium") || defaultMedium,
        campaignName: query.get("utm_campaign") || defaultCampaign,
        campaignSource: query.get("utm_source") || defaultSource,
    };
};
const useUTMValues = () => {
    const [utmValues, setUtmValues] = (0, react_1.useState)({
        campaignMedium: DEFAULT_UTM_MEDIUM_OLD_DEEP_LINK,
        campaignName: DEFAULT_UTM_CAMPAIGN_OLD_DEEP_LINK,
        campaignSource: DEFAULT_UTM_SOURCE_OLD_DEEP_LINK,
    });
    (0, react_1.useEffect)(() => {
        const values = getCampaignUTMs();
        setUtmValues(values);
    }, []);
    return utmValues;
};
exports.useUTMValues = useUTMValues;
